// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_X20","cls2":"AuthorPopover-cls2_V_v AuthorPopover-cls1_X20"};